import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Clintes.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import client1 from "./images/Design-and-Printing.jpg";
import client2 from "./images/Design-and-Printing.jpg";
import client3 from "./images/Design-and-Printing.jpg";
import client4 from "./images/Design-and-Printing.jpg";
import client5 from "./images/Design-and-Printing.jpg";
import client6 from "./images/Design-and-Printing.jpg";
import heroBackground from "./images/billboard-clients.jpg";

export default function Clintes() {
  const clients = [
    { id: 1, logo: client1, name: "Client 1" },
    { id: 2, logo: client2, name: "Client 2" },
    { id: 3, logo: client3, name: "Client 3" },
    { id: 4, logo: client4, name: "Client 4" },
    { id: 5, logo: client5, name: "Client 5" },
    { id: 6, logo: client6, name: "Client 6" },

    { id: 7, logo: client1, name: "Client 1" },
    { id: 8, logo: client2, name: "Client 2" },
    { id: 9, logo: client3, name: "Client 3" },
    { id: 10, logo: client4, name: "Client 4" },
    { id: 11, logo: client5, name: "Client 5" },
    { id: 12, logo: client6, name: "Client 6" },
  ];

  return (
    <div className="Clintes">
      <NavBar />
      <section className="clients-hero">
        <div className="hero-background">
          <img
            src={heroBackground}
            alt="Our Valued Clients"
            className="hero-bg-image"
          />
          <div className="hero-overlay"></div>
        </div>

        <div className="hero-content">
          <div className="container">
            <h1 className="client-hero-title">Our Valued Partners</h1>
            <p className="client-hero-subtitle">
              Building lasting relationships with industry leaders and
              innovative brands
            </p>
            {/* <button className="client-cta-button">Discover Our Work</button> */}
            {/* <div className="scroll-indicator">
              <div className="scroll-arrow"></div>
            </div> */}
          </div>
        </div>
      </section>

      <div className="clients-slider-container">
        <div className="slider-track ">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={"auto"}
            speed={5000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            freeMode={true}
            allowTouchMove={false}
            className="auto-slider"
          >
            {clients.map((client) => (
              <SwiperSlide key={client.id} className="client-slide">
                <div className="client-logo-item">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="client-logo"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <Footer />
    </div>
  );
}
